import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'cross-fetch';

import SearchDocuments from "./Features/SearchDocuments";
import DocumentTypeaheadResults from "./Features/DocumentTypeaheadResults";
import MobileFacets from '../search/Features/Facets/MobileFacets';
import Facets from '../search/Features/Facets/Facets';
import * as Attributes from '../search/Infrastructure/attributes';
import { getResultAttributes } from '../search/Infrastructure/attributes';
import PaginationContainer from '../search/components/PaginationContainer';
import { addResourceStrings, translateResourceString } from '../util/translationUtility';


const MIN_LENGTH = 3;
const TYPE_INTERVAL_IN_MS = 300;

class DocumentSearchApp extends React.Component {
    constructor(props) {
        super(props);
        
        this.maxAutocompleteSuggestions = 5;

        this.state = {
            itemNumber: props.ItemNumber,
            lotNumber: props.LotNumber,
            searchString: props.ItemNumber ? props.ItemNumber : props.LotNumber ? props.LotNumber : '',
            suggestestedItemNumbers: [], 
            showSuggestions: false,
            documents: props.Documents,
            showMobileFacets: false,
            attributes: getResultAttributes(props.Filters.Attributes),
            displayLotValidationErr: false,
            displayItemNumberValidationErr: false,
            autoCompleteSelectedIndex: -1
        };

        addResourceStrings(props.LocalizationItems);

        if (window !== undefined && window.$ !== undefined) {
            this.noResults = window.$(".js-document-search-no-results");
            this.documentRequestForm = window.$(".forms-section");
        }

        this.onItemNumberChange = this.onItemNumberChange.bind(this);
        this.onItemNumberKeyUp = this.onItemNumberKeyUp.bind(this);
        this.onLotNumberChange = this.onLotNumberChange.bind(this);
        this.onLotNumberKeyUp = this.onLotNumberKeyUp.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCofASearch = this.onCofASearch.bind(this);
        this.onDocumentSearch = this.onDocumentSearch.bind(this);
        this.replaceQueryString = this.replaceQueryString.bind(this);
        this.onShowMobileFacetsChange = this.onShowMobileFacetsChange.bind(this);
        this.onShowMobileFacetsToggle = this.onShowMobileFacetsToggle.bind(this);
        this.onToggleFacetExpanded = this.onToggleFacetExpanded.bind(this);
        this.onToggleShowMoreFacet = this.onToggleShowMoreFacet.bind(this);
        this.onAttributeChange = this.onAttributeChange.bind(this);
        this.onTypeaheadResultClick = this.onTypeaheadResultClick.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onLostFocus = this.onLostFocus.bind(this);
        this.needsToSearch = this.needsToSearch.bind(this);
        this.onClearAttributes = this.onClearAttributes.bind(this)
        this.clearLotNumber = this.clearLotNumber.bind(this);
        this.clearItemNumber = this.clearItemNumber.bind(this);
    }

    componentDidMount() {
        if ((!!this.props.ItemNumber || !!this.props.LotNumber) && (!this.props.Documents || this.props.Documents.length === 0)) {
            this.noResults.removeClass("d-none");
            this.documentRequestForm.removeClass("d-none").slideDown();
        }
    }

    onTypeaheadResultClick(item) {
        this.setState({ itemNumber: item, suggestestedItemNumbers: [] }, () => this.onDocumentSearch());
    }

    onFocus() {
        this.setState({ showSuggestions: true});
    }

    onLostFocus() {
        setTimeout(() => this.setState({ showSuggestions: false, autoCompleteSelectedIndex: - 1}), 300);
    }

    onShowMobileFacetsChange(showMobileFacets) {
        this.setState({ showMobileFacets });
    }

    onShowMobileFacetsToggle() {
        const { showMobileFacets } = this.state;
        this.setState({ showMobileFacets: !showMobileFacets });
    }

    onToggleFacetExpanded(facetName) {

        this.setState({
            attributes: Attributes.toggleExpandAttribute(
                this.state.attributes,
                facetName
            )
        });

    }

    onToggleShowMoreFacet(facetName) {
        this.setState({
            attributes: Attributes.toggleShowMoreAttribute(
                this.state.attributes,
                facetName
            )
        });
    }

    onAttributeChange(name, value) {
        this.setState({
            attributes: Attributes.toggleAttribute(this.state.attributes, name, value)
        });
    }

    onClearAttributes() {
        this.setState({
            attributes: Attributes.clearAttributes(this.state.attributes)
        });
    }

    onItemNumberChange(e) {
        this.updateItemNumber(e.target.value);
    }

    clearItemNumber(e) {
        this.setState({ itemNumber: "" });
    }

    updateItemNumber = (value) => {
        this.setState({ itemNumber: value });
        if (value.length === 0) 
        {
            this.setState({ suggestestedItemNumbers: [], showSuggestions: false});
            return;
        }
        if (this.needsToSearch(value)) {
            clearTimeout(this.fetchIntervalId);
            this.fetchIntervalId = setTimeout(() => this.itemNumberAutocomplete(value), TYPE_INTERVAL_IN_MS)
        }
        this.noResults.addClass('d-none');
    }

    needsToSearch(searchKey) {
        return searchKey && searchKey.length > MIN_LENGTH && (!this.state.suggestestedItemNumbers || !this.state.suggestestedItemNumbers[searchKey]);
    }

    itemNumberAutocomplete(itemNumber) {
        const { ApiEndPoint } = this.props;
        fetch(`${ApiEndPoint}?itemNumber=${itemNumber}`)
            .then(response => response.json())
            .then(result => this.setItemNumberAutocomplete(result, itemNumber));
    }

    setItemNumberAutocomplete(result, itemNumber) {
        if (!result || !result.documents) return;
        
        let itemNumbers = [...new Set(result.documents.flatMap(x => x.ErpItems)
            .filter(x => x.toLowerCase().includes(itemNumber.toLowerCase())))]
            .slice(0, this.maxAutocompleteSuggestions);
        let showSuggestions = itemNumbers && itemNumbers.length > 0;
        this.setState({ suggestestedItemNumbers: itemNumbers, showSuggestions: showSuggestions});
    }

    onItemNumberKeyUp(e) {
        if (e.keyCode === 13) {
            this.onLostFocus();
            if (this.state.autoCompleteSelectedIndex > -1 && this.state.suggestestedItemNumbers.length > this.state.autoCompleteSelectedIndex){
                this.onTypeaheadResultClick(this.state.suggestestedItemNumbers[this.state.autoCompleteSelectedIndex])
                
            } else {
                this.onDocumentSearch();
            }
        } else if (e.keyCode === 40) {
            let newIndex = this.state.autoCompleteSelectedIndex === this.state.suggestestedItemNumbers.length - 1? 0 : this.state.autoCompleteSelectedIndex + 1;
            this.setState({ autoCompleteSelectedIndex: newIndex});
        } else if (e.keyCode === 38) {
            let newIndex = this.state.autoCompleteSelectedIndex === 0 ? this.state.suggestestedItemNumbers.length - 1  : this.state.autoCompleteSelectedIndex - 1;
            this.setState({ autoCompleteSelectedIndex: newIndex});
        } else if (e.keyCode === 27) {
            this.setState({ autoCompleteSelectedIndex: -1, showSuggestions: false});
        }
    }

    onLotNumberChange(e) {
        this.setState({ lotNumber: e.target.value });
        this.noResults.addClass('d-none');
    }
     
    onLotNumberKeyUp(e) {
        if (e.keyCode === 13) {
            this.onCofASearch();
        }
    }

    clearLotNumber(e) {
        this.setState({ lotNumber: "" });
    }

    onCofASearch() {
        if (!!this.state.lotNumber) {
            this.setState({ displayLotValidationErr: false, itemNumber: "",  searchString: this.state.lotNumber });
            this.onSearch(this.state.lotNumber, "");
            return;
        }

        this.setState({ displayLotValidationErr: true });
    }

    onDocumentSearch() {
        this.setState({autoCompleteSelectedIndex: -1});
        if (!!this.state.itemNumber) {
            this.setState({ displayItemNumberValidationErr: false, lotNumber: "", searchString: this.state.itemNumber });
            this.onSearch("", this.state.itemNumber);
            return;
        }
        this.setState({ displayItemNumberValidationErr: true })
    }

    onSearch(lotNumber, itemNumber) {
        lotNumber = lotNumber.trim();
        itemNumber = itemNumber.trim();
        this.setState({ lotNumber: lotNumber, itemNumber: itemNumber });

        this.replaceQueryString(lotNumber, itemNumber);
        const { ApiEndPoint } = this.props;
        fetch(`${ApiEndPoint}?itemNumber=${itemNumber}&lotNumber=${lotNumber}`)
            .then(response => response.json())
            .then(result => this.setSearchResult(result));
    }

    setSearchResult(result) {
        var showNoResults = ((this.state.itemNumber || this.state.lotNumber) && (!result.documents || result.documents.length === 0));
        this.noResults.toggleClass('d-none', !showNoResults);
        this.setState({ documents: result.documents, attributes: getResultAttributes(result.filters.Attributes) });
        this.documentRequestForm.removeClass("d-none").slideDown();
    }

    replaceQueryString(lotNumber, itemNumber) {
        if (window.history.replaceState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?itemNumber=${itemNumber}&lotNumber=${lotNumber}`;
            window.history.replaceState({ path: newurl }, '', newurl);
        }
    }

    render() {
        let attributes = this.state.attributes;
        const facets = attributes ? attributes.length > 0 : false;
        const showClearAttributes = attributes.filter(
            attribute => attribute.values.filter(
                value => value.checked).length > 0).length > 0;
    

        let selectedAttributes = Attributes.selectedAttributes(this.state.attributes);
        let selectedTypes = selectedAttributes.filter(x => x.name === "type").map(x => x.value);
        let selectedLanguages = selectedAttributes.filter(x => x.name === "language").map(x => x.value);

        let documents = selectedTypes && selectedTypes.length > 0 ? this.state.documents.filter(doc => selectedTypes.includes(doc.Type)) : this.state.documents;
        documents = selectedLanguages && selectedLanguages.length > 0 ? documents.filter(doc => selectedLanguages.includes(doc.Language)) : documents;

        return (
            <div className="document-search-app">
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <div className="mb-3 document-search-app__instructions" dangerouslySetInnerHTML={{ __html: this.props.CofAInstructions }} />
                        <div className="form-gray">
                            <div className="form-group" style={{ width: '90%', float: 'unset' }}>
                                <label for="lotNumber">
                                    <p>{translateResourceString("/DocumentSearch/SearchBy")} {translateResourceString("/DocumentSearch/LotNumber")}</p></label>
                                <div className='d-flex flex-wrap'>
                                    <div className='mr-3 input-group' style={{ width: '60%' }}>
                                        <input
                                            id="lotNumber"
                                            type="text"
                                            className="form-control"
                                            value={this.state.lotNumber}
                                            onKeyUp={this.onLotNumberKeyUp}
                                            onChange={this.onLotNumberChange}
                                            required
                                        />
                                         {!!this.state.lotNumber &&
                                            <button type="button" id="lotNumberDeleteButton" className="btn bg-transparent header-clear-search-button" aria-label={translateResourceString("/Typeahead/DeleteLabel")} role="button" onClick={this.clearLotNumber}>
                                                <span className="fa fa-times"></span>
                                            </button>
                                        }
        

                                    </div>
                                    
                                    <input
                                        type="button"
                                        value={translateResourceString("/DocumentSearch/SearchButtonText")}
                                        onClick={this.onCofASearch}
                                        className="mt-1 mb-3 btn btn-neogen-green"
                                    />
                                     {this.state.displayLotValidationErr &&
                                            <span className='error-message'>{translateResourceString("/DocumentSearch/LotNumberRequired")}</span>
                                        }
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3 document-search-app__instructions" dangerouslySetInnerHTML={{ __html: this.props.TechnicalDocumentsInstructions }} />
                        <div className="form-gray">
                            <div className="form-group" style={{ width: '90%', float: 'unset' }}>
                                <label for="itemNumber">
                                    <p>{translateResourceString("/DocumentSearch/SearchBy")} {translateResourceString("/DocumentSearch/ItemNumber")}</p></label>
                                <div className='d-flex flex-wrap'>
                                    <div className='mr-3 input-group' style={{ width: '60%' }}>
                                        <input
                                            id="itemNumber"
                                            type="text"
                                            className="form-control"
                                            value={this.state.itemNumber}
                                            onKeyUp={this.onItemNumberKeyUp}
                                            onChange={this.onItemNumberChange}
                                            onFocus={this.onFocus}
                                            onBlur={this.onLostFocus}
                                            autoComplete="off"
                                            required
                                        />
                                        {this.state.showSuggestions && this.state.suggestestedItemNumbers && this.state.suggestestedItemNumbers.length > 0 && 
                                            <DocumentTypeaheadResults
                                                itemNumbers={this.state.suggestestedItemNumbers}
                                                onTypeaheadResultClick={this.onTypeaheadResultClick}
                                                selectedIndex={this.state.autoCompleteSelectedIndex}
                                            />}
                                         {!!this.state.itemNumber &&
                                            <button type="button" id="itemNumberDeleteButton" className="btn bg-transparent header-clear-search-button" aria-label={translateResourceString("/Typeahead/DeleteLabel")} role="button" onClick={this.clearItemNumber}>
                                                <span className="fa fa-times"></span>
                                            </button>
                                        }
                                   </div>   
                                    <input
                                        type="button"
                                        value={translateResourceString("/DocumentSearch/SearchButtonText")}
                                        onClick={this.onDocumentSearch}
                                        className="mt-1 mb-3 btn btn-neogen-green"
                                    />
                                    {this.state.displayItemNumberValidationErr &&
                                            <span className='col-12 error-message'>{translateResourceString("/DocumentSearch/ItemNumberRequired")}</span>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                {this.state.documents && this.state.documents.length > 0 && this.state.searchString &&
                    <div className='d-flex justify-content-between'>
                        <h1 className="heading-lg mt-4 mb-4">
                            {translateResourceString("/DocumentSearch/SearchForText")} "{this.state.searchString}"
                        </h1>

                        <div className="d-flex align-items-center"> {translateResourceString("/DocumentSearch/ResultCount")} {documents.length}</div>
                    </div>
                }
                {this.state.documents && this.state.documents.length > 0 && facets &&
                     <div className={`mb-4 category-list-top-pagination-wrapper ${showClearAttributes ? "" : "d-lg-none"}`}>
                         <PaginationContainer
                             pagination={{}}
                             paginationFirstItemIndex={1}
                             showClearAttributes={showClearAttributes}
                             onClearAttributes={this.onClearAttributes}
                             onAttributeChange={this.onAttributeChange}
                             onShowMobileFacetsToggle={this.onShowMobileFacetsToggle}
                             attributes={attributes}
                             useLoadMoreButton={false}
                             alwaysShowResultsTotal={true}
                        />
                    </div>
                }

                { this.state.lotNumber && this.state.documents && this.state.documents.length > 0 && facets &&
                    <div className={`d-flex align-items-center ${showClearAttributes ? "" : "d-lg-none"}`}> {translateResourceString("/DocumentSearch/AdditionalItemNumberNote")}</div>
                }
               

                {this.state.documents && this.state.documents.length > 0 && facets &&
                    <MobileFacets
                        attributes={attributes}
                        onAttributeChange={this.onAttributeChange}
                        onClearAttributes={this.onClearAttributes}
                        showMobileFacets={this.state.showMobileFacets}
                        onShowMobileFacetsChange={this.onShowMobileFacetsChange}
                        onToggleFacetExpanded={this.onToggleFacetExpanded}
                        onToggleShowMoreFacet={this.onToggleShowMoreFacet}
                    />
                }


                {this.state.documents && this.state.documents.length > 0 &&
                    <div className='row'>
                        <div className="col-lg-3 d-none d-lg-block">
                            {facets &&
                                <Facets
                                    attributes={attributes}
                                    onAttributeChange={this.onAttributeChange}
                                    onClearAttributes={this.onClearAttributes}
                                    onToggleFacetExpanded={this.onToggleFacetExpanded}
                                    onToggleShowMoreFacet={this.onToggleShowMoreFacet}
                                />
                            }
                            { this.state.lotNumber && facets && 
                                <div className="d-flex align-items-center"> {translateResourceString("/DocumentSearch/AdditionalItemNumberNote")}</div>
                            }
                        </div>

                    <div className="col-12 col-lg-9 mt-3">
                            {documents && documents.length > 0 ?
                                <SearchDocuments
                                    items={documents}
                                    isCofADocument={this.state.lotNumber && this.state.lotNumber.length !== 0}
                                /> 
                                : <p className="no-results-with-filters">{translateResourceString("/DocumentSearch/NoResultsWithFilters")}</p>
                            }
                        </div>
                    </div>

                }

            </div>

        );
    }
}

DocumentSearchApp.propTypes = {
    ApiEndPoint: PropTypes.string,
    LocalizationItems: PropTypes.array,
    Documents: PropTypes.arrayOf(PropTypes.object),
    ItemNumber: PropTypes.string,
    LotNumber: PropTypes.string
};

export default DocumentSearchApp;